import _extends from "@babel/runtime/helpers/extends";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "../../../store";
import SearchTable from "../components/SearchTable";
import { fetchHsCodes } from "../state/actions";
import useQueryParams from "../../../hooks/useQueryParams";
import { selectors as appSelectors } from "../../App";
import { hsCodesHasErrorSelector, hsCodesSelector, isHsCodesLoadingSelector } from "../state/selectors";
import useLanguage from "../../Translation/hooks/useLanguage";
import { downloadSearchData } from "../dataProvider";

const SearchTableContainer = props => {
  const [queryParams] = useQueryParams();
  const hsCodes = useSelector(hsCodesSelector);
  const isLoading = useSelector(isHsCodesLoadingSelector);
  const hasError = useSelector(hsCodesHasErrorSelector);
  const config = useSelector(appSelectors.configSelector);
  const {
    language,
    dir
  } = useLanguage();
  const isRtl = dir === "rtl";
  const dispatch = useDispatch();
  useEffect(() => {
    const countryCode = config.countryCode || queryParams.country;

    if (queryParams.q && countryCode) {
      dispatch(fetchHsCodes({
        searchString: queryParams.q,
        countryCode,
        onShowError: config.onShowError
      }));
    } // Load only on did mount
    // eslint-disable-next-line

  }, [language]);
  const handleDownloadTariff = useCallback(() => {
    downloadSearchData("TariffBook", "", language);
  }, [language]);
  return /*#__PURE__*/React.createElement(SearchTable, _extends({
    onDownload: handleDownloadTariff,
    hsCodes: hsCodes,
    isRtl: isRtl,
    isLoading: isLoading,
    colors: config.colors,
    onProvideFeedback: config.onProvideFeedback,
    isDeclare: config.isDeclare,
    hasError: hasError
  }, props));
};

__signature__(SearchTableContainer, "useQueryParams{[queryParams]}\nuseSelector{hsCodes}\nuseSelector{isLoading}\nuseSelector{hasError}\nuseSelector{config}\nuseLanguage{{ language, dir }}\nuseDispatch{dispatch}\nuseEffect{}\nuseCallback{handleDownloadTariff}", () => [useQueryParams, useSelector, useSelector, useSelector, useSelector, useLanguage, useDispatch]);

const _default = /*#__PURE__*/React.memo(SearchTableContainer);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SearchTableContainer, "SearchTableContainer", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/SearchTableContainer.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/SearchTableContainer.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();